import Trash from 'react-icons/lib/fa/trash';
export default Trash;



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/theme/icons/Trash.js